<div class="header">
  <img src="assets/logo.png" class="logo">
</div>
<div class="error">
  <span class="phrase">お探しのページは</span><span class="phrase">見つかりませんでした。</span>
  <br /><br />
  <span class="phrase">URLが変更・削除されたか、</span><span class="phrase">一時的に閲覧できない</span><span class="phrase">可能性があります。</span>
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />
</div>
